(() => {
  if (customElements.get('fourpaw-cart-shipping')) return;

  // Reuse the PDP's request and session cache; do not start a second geo lookup.
  const cacheKey = 'fourpaw-us-region-v2';
  const states = new Set([
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
    'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
    'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
    'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
    'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
    'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
    'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
    'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia',
    'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'District of Columbia',
  ]);
  const validateState = (value) => typeof value === 'string' && states.has(value.trim()) ? value.trim() : '';

  async function fetchState() {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 2200);
    try {
      const response = await fetch('https://get.geojs.io/v1/ip/geo.json', {
        cache: 'no-store', credentials: 'omit', referrerPolicy: 'no-referrer',
        signal: controller.signal,
      });
      if (!response.ok) return '';
      const location = await response.json();
      return location.country_code === 'US' ? validateState(location.region) : '';
    } catch (_) {
      return '';
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function getState() {
    try {
      const cached = validateState(window.sessionStorage.getItem(cacheKey));
      if (cached) return cached;
    } catch (_) {
      // Storage is optional in privacy modes.
    }
    if (!window.fourpawUsRegionLookup) window.fourpawUsRegionLookup = fetchState();
    const state = validateState(await window.fourpawUsRegionLookup);
    if (state) {
      try { window.sessionStorage.setItem(cacheKey, state); } catch (_) { /* Optional cache. */ }
    }
    return state;
  }

  customElements.define('fourpaw-cart-shipping', class extends HTMLElement {
    // Native cart section replacements reconnect the element automatically.
    connectedCallback() {
      if (this.dataset.countryCode !== 'US') return;
      getState().then((state) => {
        if (!state || !this.isConnected || this.dataset.countryCode !== 'US') return;
        const value = this.querySelector('[data-shipping-value]');
        const template = this.dataset.stateTemplate || '';
        if (value && template.includes('[destination]')) {
          value.textContent = template.replace('[destination]', state);
        }
      }).catch(() => { /* Retain the server-rendered FREE fallback. */ });
    }
  });
})();
